import { ArrowForwardIos } from "@mui/icons-material";
import { LiveKitRoom } from "@livekit/components-react";
import axios from "axios";
import { Fragment, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useGetAllPatientAppointments } from '../api/hooks/patient/allPatientAppointmentList';
import DashboardLayout from "../components/dashboard/DashboardLayout";
import HealthTipCard from "../components/dashboard/HealthTipCard";
import MedicalCardOne from "../components/dashboard/MedicalCardOne";
import UpcomingEventCard from "../components/dashboard/UpcomingEventCard";
import { usePostMeeting } from "../components/meetings/hooks/postMeeting";
import { TempleLiveKitPatientMeeting } from "../components/meetings/TempleLiveKitPatientMeeting";
import Button from "../components/shared/Button";
import { Loading } from "../components/shared/Loading";
import { EmptyMsgIcon, GeneralMedIcon, MentalHealthIcon } from "../svgs";
import { useGetPatientProfileDetails } from "../api/hooks/accounts/getPatientProfileDetails";

const Dashboard = () => {
  const [joinCall, setJoinCall] = useState(false);
  const [appointmentInfo, setAppointemntInfo] = useState<any | null>(null);
  const [didCallEnd, setDidCallEnd] = useState<boolean>(false);

    const { patientProfileDetails } = useGetPatientProfileDetails();
  const searchParams = useSearchParams()[0];
  const referrer = searchParams.get("referrer");

  const navigate = useNavigate();

  const { appointmentsList, isFetching: isFetchingAppointments, isError: isAppointmentsError, error: AppointmentsError } = useGetAllPatientAppointments()

  useEffect(() => {
    if (referrer === "appointment") {
      navigate(
        "/dashboard/dependent/visit/schedule/landingpage?referrer=appointment"
      );
    }
    // fetchAppointmentsLists();
  }, [navigate, referrer]);

  useEffect(() => {
    if (didCallEnd) {
      setJoinCall(false);
      // setShowChargeSheetModal(true);
      setDidCallEnd(false);
    }
  }, [didCallEnd]);

  const handleJoinCallClick = () => {
    postMeeting({
      appointmentId: appointmentInfo?.appointmentId
    });
    setJoinCall(true)
  };

  useEffect(() => {
    if (appointmentsList.length > 0) {
      (appointmentsList || [])?.forEach(appointment => {
        const appointmentDate = new Date(appointment?.appointmentDate);
        const now = new Date();
        const timeDifference = appointmentDate.getTime() - now.getTime();
        const minutesDifference = timeDifference / (1000 * 60);
        // show toast if within 30 minutes
        if (minutesDifference <= 30) {
          toast('Your appointment is in less than 30 minutes!', {
            toastId: "toastId",
          });
        }
      });
    }
  }, [appointmentsList]);

  const { postMeeting, isPending, data } = usePostMeeting()
  console.log(data)

  if (isFetchingAppointments || isPending) {
    return (
      <div className="fixed inset-0 z-[10000000] backdrop-blur-sm flex justify-center w-full h-screen items-center">
        <Loading />
      </div>
    )
  }

  if (isAppointmentsError) {
    toast.error(AppointmentsError?.error, {
      toastId: "toastId",
    })
  }


  return (
    <Fragment>
      {
        joinCall ? (
          <TempleLiveKitPatientMeeting
            appointmentId={appointmentInfo?.appointmentId || ""}
            liveKitResponse={data}
            setJoinCall={setJoinCall}
            providerName={`${appointmentInfo?.firstName}` || ""}
          />
        ) :
          (
            <DashboardLayout>
              <div className="w-full px-2  mt-[20px] lg:mt-[30px]">
                <div className="w-full flex flex-col">
                  <div className="flex lg:flex-nowrap flex-wrap w-full items-center justify-start">
                    <div className="w-full">
                      <MedicalCardOne
                        icon={<GeneralMedIcon />}
                        title="General Medicine"
                        description="Get care for conditions like cold, cough,
            flu exposure, sore throat, minor injuries, pink eye, UTI and more."
                        body={
                          <Button
                            width={350}
                            height={60}
                            onClick={() => {
                              if (!patientProfileDetails?.user?.stripeId) {
                                toast.warning('Kindly fill in your profile details to continue', {
                                  toastId: 'profile-details-required',
                                  autoClose: 5000
                                });
                                navigate('/patient/my-account');
                                return;
                              }
                              navigate("/dashboard/dependent/visit/schedule", {
                                replace: true,
                                state: {
                                  pageFrom: "/patient/dashboard",
                                  hasPreviousProvider: null
                                }
                              });
                            }}
                            variant="primary"
                            label="Schedule an Appointment"
                            // disabled={patientProfileDetails?.user?.stripeId}
                          />
                        }
                      />
                    </div>
                    <div className="hidden lg:block w-4" />
                    <div className="w-full mt-4 lg:mt-0">
                      <MedicalCardOne
                        icon={<MentalHealthIcon />}
                        title="Mental Health"
                        description="Speak to our licensed therapists & psychiatrists about addictions, anxiety, bipolar disorder, depression, grief, PTSD and more."
                        body={
                          <Button
                            onClick={() =>
                            {
                              if (!patientProfileDetails?.user?.stripeId) {
                                toast.warning('Kindly fill in your profile details to continue', {
                                  toastId: 'profile-details-required',
                                  autoClose: 5000
                                });
                                navigate('/patient/my-account');
                                return;
                              }
                              navigate("/dashboard/dependent/visit/schedule/health");
                            }}
                            width={350}
                            height={60}
                            variant="primary"
                            label="Schedule an Appointment"
                          />
                        }
                        yellow={true}
                      />
                    </div>
                    <div className="block lg:hidden h-2" />
                    <div className="w-full lg:h-[50vh] flex flex-col items-start justify-start lg:ml-2">
                      < div className="w-full flex justify-between items-center pb-4">
                        <div className="text-[#324705] text-[28px] lg:text-[14px] font-[600]">
                          Upcoming events
                        </div>
                        <div className="flex justify-end items-center text-[#7E954B] text-[16px] font-[500]">
                          View all <ArrowForwardIos className="arrow" />
                        </div>
                      </div>

                      {
                        appointmentsList && appointmentsList?.length ? (
                          appointmentsList?.map((eventItem) => (
                            <Fragment key={eventItem?.id}>
                              <UpcomingEventCard
                                handleJoinCallClick={() => {
                                  handleJoinCallClick()
                                  setAppointemntInfo(eventItem)
                                  postMeeting({ appointmentId: eventItem?.appointmentId }, {
                                    onError: (error) => {
                                      toast.error(axios.isAxiosError(error) ? error?.response?.data?.error : error?.message, {
                                        type: "error",
                                        isLoading: false,
                                        autoClose: 5000,
                                        closeButton: true,
                                        toastId: 'toastId',
                                      });
                                    }
                                  })
                                }}
                                name={`${eventItem?.firstName} ${eventItem?.lastName}`}
                                type={eventItem?.title}
                                title={
                                  eventItem?.specialty === "psychiatrist"
                                    ? "Psychiatrist"
                                    : eventItem?.specialty === "pcp"
                                      ? "Primary Care Physician"
                                      : "Therapist"
                                }
                                startTime={eventItem?.appointmentStartTime}
                                endTime={eventItem?.appointmentEndTime}
                                appointmentDate={new Date(eventItem?.appointmentDate)}
                              />
                            </Fragment>
                          ))
                        ) : (
                          <>
                            <div className="e-empty h-full w-full m-auto flex flex-col justify-center items-center rounded-[10px]">
                              <EmptyMsgIcon />
                              <div className="font-semibold text-[#34623f] mt-4 text-center">
                                Nothing here
                              </div>
                              <div className="text-[#103C1B] font-[400] pt-2 w-full text-center">
                                You don’t have any upcoming events 🙂
                              </div>
                            </div>
                          </>
                        )}

                    </div>
                  </div>
                  <div className="h-[24px]" />
                  <div className="w-full">
                    {/* TODO:  map health tips here when available */}
                    <div className="w-full font-[600] text-[28px] text-[#103C1B] text-left flex justify-start ">
                      Get more involved with your health
                    </div>
                    <div className="h-4" />
                    <div className=" w-full  lg:w-[66.3%] flex flex-col items-start justify-start m-0 p-0">
                      <HealthTipCard
                        description="Why You Shouldn’t Worry About Ibuprofen And Heart Attacks."
                        imageUrl="/assets/images/health-tip1.png"
                      />
                      <div className="h-4" />
                      <HealthTipCard
                        description="Eating Oats thrice a week can help lower your cholesterol level fast."
                        imageUrl="/assets/images/health-tip2.png"
                      />
                      <div className="h-[40px]" />
                    </div>
                  </div>
                </div>
                <div className="h-[40px]" />
              </div>
            </DashboardLayout>
          )
      }
    </Fragment>
  );
};

export default Dashboard;
